import {Injectable} from '@angular/core';
import {RouterStateSnapshot, ActivatedRouteSnapshot, Router, CanActivate} from '@angular/router';
import {LoadUserAction} from "../ngrx/actions/user.action";
import {Store} from "@ngrx/store";
import * as wjcCore from "@grapecity/wijmo";

@Injectable()
export class AdminGuard implements CanActivate {
    user: any;

    constructor(private router: Router, private store: Store<any>) {
        this.store.dispatch(new LoadUserAction())
        this.store.select<any>("lotasFeature").subscribe((lotas: any) => {
            this.user = lotas.user.user;
        });
    }

    canActivate(next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot) {
        if (wjcCore.isArray(this.user.roles)) {
            for (let role of this.user.roles) {
                // 支部管理者 (例: 群馬管理者) か、全支部管理者 (name='管理者' / state='システム')。
                // 全支部管理者は category を持たないので name でも判定する。
                if (role.category == "管理者" || role.name == "管理者") {
                    return true;
                }
            }
        }
        console.log("AdminGuard Not Admin")
        this.router.navigateByUrl('main/user');
        return false;
    }
}
